import React from 'react';
import { StarIcon } from 'lucide-react';
import { Avatar } from './Avatar';
import { avatarColors } from '../data/coaches';
import type { CoachProfile, Testimonial } from '../data/testimonials';
type TestimonialsProps = {
  testimonials: Testimonial[];
  profiles?: CoachProfile[];
  title?: string;
  subtitle?: string;
  background?: 'white' | 'cream';
};

/** Renders nothing until data/testimonials.ts holds real buyer reviews. */
export function Testimonials({
  testimonials,
  profiles = [],
  title = 'What coaches are saying',
  subtitle = 'From rec gymnastics coaches teaching mixed-level classes.',
  background = 'white'
}: TestimonialsProps) {
  if (testimonials.length === 0) return null;
  const bg = background === 'white' ? 'bg-white' : 'bg-cloud';
  return <section aria-label={title} className={`w-full text-ink ${bg}`} data-id="element-361" data-mp="2s42wzjh3p4x5">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-362" data-mp="v8wvafg59ufc">
        <div className="text-center" data-id="element-363" data-mp="qa3ot6z9z3oo">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-coral-deep" data-id="element-364" data-mp="qb50ndo47u7g">Coach to coach</p>
          <h2 className="mt-3 font-display text-3xl font-extrabold text-ink sm:text-5xl" data-id="element-365" data-mp="h8181pbqwil0">{title}</h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-slate" data-id="element-366" data-mp="m2ygov544pxd">{subtitle}</p>
        </div>

        {profiles.length > 0 && <div className="mt-9 grid gap-6 border-y border-cloud-dark py-7 sm:grid-cols-2 sm:gap-10" data-id="element-367" data-mp="c6btw0t87osp">
            {profiles.map((profile, i) => <figure key={profile.name} className="flex gap-4" data-id="element-368" data-mp="zwxzllfrcwzj" data-mpi={i}>
                <Avatar name={profile.name} color={avatarColors[(i + 1) % avatarColors.length]} className="h-12 w-12 flex-none" data-id="element-369" data-mp="14vsjkqpgorl8" />
                <div data-id="element-370" data-mp="q63dch2ihxe3">
                  <figcaption data-id="element-371" data-mp="q4sbimsmmzpm">
                    <span className="block font-display text-lg font-extrabold leading-tight text-ink" data-id="element-372" data-mp="v57lr5hm3r3d">{profile.name}</span>
                    <span className="text-xs font-semibold uppercase tracking-wider text-coral-deep" data-id="element-373" data-mp="1iu8y33tkfmdx">{profile.role}</span>
                  </figcaption>
                  <blockquote className="mt-2 text-sm leading-relaxed text-slate" data-id="element-374" data-mp="1xi0nba9elvyn">“{profile.bio}”</blockquote>
                </div>
              </figure>)}
          </div>}

        <div className={`mt-9 grid gap-4 ${testimonials.length === 1 ? 'mx-auto max-w-md' : 'sm:grid-cols-2 lg:grid-cols-3'}`} data-id="element-375" data-mp="1sh38n7nlrk1w">
          {testimonials.map((item, i) => <figure key={item.author} className="flex flex-col rounded-2xl border border-cloud-dark bg-white p-5 shadow-soft" data-id="element-376" data-mp="1eiv4aeo8lggp" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-377" data-mp="19rddgjfxgw9g">
                <Avatar name={item.author} src={item.avatar} color={avatarColors[i % avatarColors.length]} className="h-11 w-11" data-id="element-378" data-mp="14tbk95osfgk9" />
                <span className="flex gap-0.5" role="img" aria-label="Five out of five" data-id="element-379" data-mp="10sjb0cfx1bnz">
                  {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-amber text-amber" aria-hidden="true" data-id="element-380" data-mp="vrvj7ojv4qsp" />)}
                </span>
              </div>
              <blockquote className="mt-3 text-sm leading-relaxed text-ink" data-id="element-381" data-mp="32fujbj3igbhi">“{item.quote}”</blockquote>
              <figcaption className="mt-auto pt-4 text-xs text-slate" data-id="element-382" data-mp="37exrhcesextp">
                <span className="block text-[13px] font-semibold text-ink" data-id="element-383" data-mp="3cfd39zjf7x9k">{item.author}</span>
                {item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}